import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=a501694a"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a501694a')) {
      api.createRecord('a501694a', component.options)
    } else {
      api.reload('a501694a', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=a501694a", function () {
      api.rerender('a501694a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/view/Documents.vue"
export default component.exports